import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { COGNITO_POOL_ID, COGNITO_CLIENT_ID } from './Constants'

const poolData = {
    UserPoolId: COGNITO_POOL_ID,
    ClientId: COGNITO_CLIENT_ID
};

export default new CognitoUserPool(poolData);